// extracted by mini-css-extract-plugin
export default {"container":"style_container__fu6r2","content":"style_content__tXukm"};